import { defineComponent, inject, ref, computed, createBlock, openBlock, unref } from "vue";
import CodSheet from "./index28.js";
import _sfc_main$2 from "./index36.js";
import _sfc_main$1 from "./index110.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductDetails",
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    product: {
      type: Object,
      default: () => void 0
    },
    /** AD-4: the API prefix — POS omits it (`/products`), admin passes '/admin'. */
    endpointBase: {
      type: String,
      default: ""
    },
    /** Full product list override (admin's server-fetched list) — default Product.all(). */
    products: {
      type: Array,
      default: () => void 0
    },
    /** Category options override — default ProductCategory.all(). */
    productCategories: {
      type: Array,
      default: () => void 0
    },
    /** Pricelist rows override — default Pricelist.all(). */
    pricelists: {
      type: Array,
      default: () => void 0
    },
    /** Full save callback (product, raw server row) — supersedes the `save` emit. */
    onSaved: {
      type: Function,
      default: void 0
    }
  },
  emits: ["update:modelValue", "save"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const backoffice = inject("kontyBackoffice", false);
    const sheetRef = ref(null);
    const open = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v)
    });
    const handleDismiss = () => emit("update:modelValue", false);
    const rootProps = computed(() => ({
      product: props.product,
      endpointBase: props.endpointBase,
      products: props.products,
      productCategories: props.productCategories,
      pricelists: props.pricelists,
      onSaved,
      onCancel: handleDismiss,
      onOpenIngredients: openIngredientsForm
    }));
    function goBack() {
      var _a;
      (_a = sheetRef.value) == null ? void 0 : _a.goBack();
    }
    function openIngredientsForm(handle) {
      var _a;
      (_a = sheetRef.value) == null ? void 0 : _a.navigate(_sfc_main$1, {
        product: props.product,
        products: props.products,
        onSave: (ingredients) => handle.setIngredientsAndSave(ingredients),
        onCancel: goBack
      });
    }
    function onSaved(product, raw) {
      var _a;
      if (props.onSaved) {
        props.onSaved(product, raw);
      } else {
        emit("save", !((_a = props.product) == null ? void 0 : _a.id) ? product : void 0);
      }
      handleDismiss();
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(CodSheet, {
        ref_key: "sheetRef",
        ref: sheetRef,
        modelValue: open.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => open.value = $event),
        width: "860px",
        height: "710px",
        guard: !unref(backoffice),
        root: _sfc_main$2,
        "root-props": rootProps.value
      }, null, 8, ["modelValue", "guard", "root-props"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index37.js.map
